/* eslint-disable unicorn/filename-case -- it is a utility function which returns a ReactNode */
import type { ComponentType } from 'react';
import { findErrors } from './find-errors';
import type { GuardedPaths, WithErrors } from './types';

const withPropertiesErrorGuard = <TProperties extends object, const TPaths extends GuardedPaths<TProperties>>(
  Component: ComponentType<TProperties>,
  paths: TPaths,
) =>
  function (properties: WithErrors<TProperties, TPaths>) {
    const errors = findErrors(properties, paths);
    const [firstError] = errors;

    if (errors.length > 1) {
      throw new AggregateError(errors, `${errors.length} properties failed`);
    }

    if (firstError) {
      throw firstError;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- errors are excluded by findErrors
    return <Component {...(properties as TProperties)} />;
  };

export default withPropertiesErrorGuard;
/* eslint-enable unicorn/filename-case -- it is a utility function which returns a ReactNode */
